import { useMemo } from 'react';
import { sidebarLimitValidator } from './utils';

const DEFAULT_SIDEBAR_LIMIT = 5;
export const useGetSidebarLimit = (value: unknown) => {
  return useMemo(
    () => sidebarLimitValidator(value, DEFAULT_SIDEBAR_LIMIT),
    [value]
  );
};
